import { Outlet, createRootRoute } from '@tanstack/react-router'
import { AppShell } from '../components/AppShell'
import { BottomNav } from '../components/BottomNav'
import '../styles/canon.css'
import '../styles/stumble-overrides.css'

// Root layout — wraps everything in AppShell (palette + grain) and renders the
// global BottomNav (F-Wave PR α / F8). BottomNav reads the current path and
// picks the right variant (standard / in-stumble) or hides itself on
// /login + /onboarding.
// Per ADR-0010: 100dvh, env(safe-area-inset-*), runtime palette switching.
export const Route = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
      <BottomNav />
    </AppShell>
  ),
})
